import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Order } from 'src/app/model/interfaces/order';
import { OrderUpdateAction } from 'src/app/model/interfaces/order-update-action';
import { OrderService, ResourceService } from 'src/app/services';

@Component({
    selector: 'app-basket-added-element',
    templateUrl: './basket-added-element.component.html',
    styleUrls: ['./basket-added-element.component.scss'],
})
export class BasketAddedElementComponent implements OnInit, OnDestroy {
    private readonly orderService: OrderService;
    private readonly resourceService: ResourceService;
    private orderUpdatedSubscription: Subscription;

    public basketNotify: boolean;
    public itemCount = 0;
    public addedItemType: string;
    public addedItemName: string;
    public addedItemNormalizedName: string;

    public constructor(resourceService: ResourceService, orderService: OrderService) {
        this.resourceService = resourceService;
        this.orderService = orderService;
    }

    public ngOnInit(): void {
        this.setUpSubscriptions();
    }

    private setUpSubscriptions(): void {
        this.orderUpdatedSubscription = this.orderService.onOrderContentUpdated.subscribe(
            (updateInfo: { order: Order; action: OrderUpdateAction }) => {
                this.orderUpdated(updateInfo.order, updateInfo.action);
            }
        );
    }

    public ngOnDestroy(): void {
        this.orderUpdatedSubscription.unsubscribe();
    }

    private orderUpdated(order: Order, action: OrderUpdateAction): void {
        const actionType = action ? action.actionType : 'unknown';

        // Filter that makes sure we only process the event when something is deleted from or added to the order.
        if (!(actionType === 'add' || actionType === 'delete')) {
            return;
        }

        this.setItem(action);
        this.setItemCount(order);

        if (this.itemCount > 0) {
            this.setItemCount(order);

            if (actionType === 'add') {
                this.itemAdded(action);
            }
        }
    }

    private itemAdded(action: OrderUpdateAction): void {
        const item = action.item;
        this.basketNotify = true;

        setTimeout(
            () => {
                this.basketNotify = false;
            },
            this.itemCount > 1 ? 2000 : 3000
        );
    }

    private setItem(action: OrderUpdateAction): void {
        if (action.itemType === 'ticketpackage') {
            this.addedItemName = action.item['Name'];
            this.addedItemType = 'package';
            this.addedItemNormalizedName = this.addedItemName;
        } else if (action.itemType === 'sharetype') {
            const name = action.item['Name'];
            this.addedItemName = this.resourceService.getString('global_share_type_name_' + name);
            this.addedItemType = 'ticket';
            this.addedItemNormalizedName = this.resourceService.getString(
                'global_ticket_normalized_name_' + action.item['Size']
            );
        } else if (action.itemType === 'share') {
            const name = action.item['Type']['Name'];
            this.addedItemName = this.resourceService.getString('global_share_type_name_' + name);
            this.addedItemType = 'ticket';
            this.addedItemNormalizedName = this.resourceService.getString(
                'global_ticket_normalized_name_' + action.item['Type']['Size']
            );
        }
    }

    private setItemCount(order: Order | null): void {
        if (order == null) {
            this.itemCount = 0;
            return;
        }

        const itemCount =
            order != null ? order.Shares.length + order.TicketPackageInstances.length : 0;
        this.itemCount = itemCount;
    }
}
